import configuredAxios from './axiosConfig';

const statisticsService = {
  async getScorers(championshipId) {
    try {
      const response = await configuredAxios.get(`/championships/${championshipId}/stats/scorers`);
      return response.data.data; // retorna apenas o array
    } catch (error) {
      console.error('Error fetching scorers:', error);
      throw error;
    }
  },

  async getAssists(championshipId) {
    try {
      const response = await configuredAxios.get(`/championships/${championshipId}/stats/assists`);
      return response.data.data;
    } catch (error) {
      console.error('Error fetching assists:', error);
      throw error;
    }
  },

  async getCards(championshipId) {
    try {
      const response = await configuredAxios.get(`/championships/${championshipId}/stats/cards`);
      return response.data.data;
    } catch (error) {
      console.error('Error fetching cards:', error);
      throw error;
    }
  },

  async getBestGoalkeepers(championshipId) {
    try {
      // Rota definida em statsRoutes.js: /statistics/goalkeepers/:id
      const response = await configuredAxios.get(`/statistics/goalkeepers/${championshipId}`);
      return response.data.data;
    } catch (error) {
      console.error('Error fetching goalkeepers:', error);
      throw error;
    }
  },

  async getAllStatistics(championshipId) {
    try {
      const [scorers, assists, cards, goalkeepers] = await Promise.all([
        this.getScorers(championshipId),
        this.getAssists(championshipId),
        this.getCards(championshipId),
        this.getBestGoalkeepers(championshipId),
      ]);

      return { scorers, assists, cards, goalkeepers };
    } catch (error) {
      console.error('Error fetching all statistics:', error);
      throw error;
    }
  },
};

export default statisticsService;